import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../../common/classes/entityComposition';
import { enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors';
import { UncomposedSinglePickerField } from './singlePickerField';
import logValueOnChange from '../commonActions/logValueOnChange';
const ReportPickerField = ({
  label,
  enabled,
  job,
  onChange,
  reportReferenceActions: {
    indexCancel,
    serverFilter,
    showCancel,
    serverShow
  },
  reportReference: {
    indexQuery,
    active,
    list: reports
  },
  reportType,
  // from format.reportType
  value: _value = null,
  thisPath
}) => {
  const reportsWithTitles = reports.map(r => ({
    id: r.id,
    title: `${r.reportTypeName} ${r.reportNumber}`
  }));

  // save the report selection in state to manage network reloads and changing reports
  const [selectedReport, setSelectedReport] = useState(_value);

  // load the available reports when component mounts
  useEffect(() => {
    serverFilter({
      job: [job],
      reportTypeIdentifier: reportType
    }, indexQuery, true);
  }, [job, reportType, indexQuery, serverFilter]);
  useEffect(() => () => {
    // clean up stale state when component unmounts
    showCancel();
    indexCancel();
  }, [indexCancel, showCancel]);

  // only change the active record once the remote report has loaded
  useEffect(() => {
    if (active && selectedReport && active.id === selectedReport.id) {
      onChange({
        path: thisPath,
        value: active
      });
    }
  }, [selectedReport, onChange, active, thisPath]);
  const handleChange = useCallback(({
    path,
    value: newSelection
  }) => {
    if (!newSelection) {
      // clear the selection
      onChange({
        path,
        value: newSelection
      });
    } else if (!selectedReport || newSelection.id !== selectedReport.id) {
      // the selected report has changed, get the details
      serverShow(newSelection.id);
    }
    setSelectedReport(newSelection);
  }, [selectedReport, onChange, serverShow]);
  return /*#__PURE__*/React.createElement(UncomposedSinglePickerField, {
    onChange: handleChange,
    options: reportsWithTitles,
    value: _value,
    valueKey: "id",
    label: label,
    enabled: enabled,
    path: thisPath
  });
};
ReportPickerField.propTypes = {
  job: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  reportReference: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({})),
    active: PropTypes.shape({
      id: PropTypes.string
    })
  }).isRequired,
  reportReferenceActions: PropTypes.shape({
    indexCancel: PropTypes.func,
    serverFilter: PropTypes.func,
    serverShow: PropTypes.func,
    showCancel: PropTypes.func
  }).isRequired,
  reportType: PropTypes.string.isRequired,
  thisPath: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  value: PropTypes.shape({})
};
export { ReportPickerField as UncomposedReportPickerField };
export default entityComposition(ReportPickerField, ['reportReference'], {
  job: state => state.report.active.Job,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  thisPath: newPathSelector,
  enabled: enabledSelector
});